import { l10n } from '@ott/l10n';

export const SIGN_IN_FORM_NAME = 'SigninForm';
export const SIGN_UP_FORM_NAME = 'SignupForm';
export const FORGOT_PASSWORD_FORM_NAME = 'ForgotPasswordForm';

export const RECAPTCHA_LANG_MAP = {
  ru: 'ru',
  'ru-ua': 'ru',
  'uk-ua': 'uk',
  'ru-kz': 'ru',
  'ru-by': 'ru',
  'en-gb': 'en-GB',
  'en-ie': 'en',
  'en-us': 'en',
  es: 'es',
  de: 'de',
  pl: 'pl',
  tr: 'tr',
};

export const RECAPTCHA_KEY = '6LePmCITAAAAAOMx5rQ7P-Ycs6rygGMBFxyxYLSS';

export const GOOGLE_OAUTH_CLIENT_ID =
  '483329208576-csq6gklqa54sjb11b5r7qe500ftgurop.apps.googleusercontent.com';

export const STATUS_CODES = {
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  UNPROCESSABLE_ENTITY: 422,
};

export const MAX_PHONE_LENGTH_WITH_SPACES = '19';

export const ERROR_CODES = {
  INVALID_PIN_PARAM: 'INVALID_PARAM: body.pin',
  PIN_EXPIRED: 'PIN_EXPIRED',
  PIN_SENT: 'PIN_SENT',
  INVALID_PIN: 'INVALID_PIN',
  SERVER_ERROR: 'SERVER_ERROR',
  PHONE_NOT_REGED: 'PHONE_NOT_REGED',
  NETWORK_CONNECTION_ERROR: 'NETWORK_CONNECTION_ERROR',
  INVALID_LOGIN: 'INVALID_LOGIN',
  INVALID_PASSWORD: 'INVALID_PASSWORD',
  EMAIL_EXISTS: 'EMAIL_EXISTS',
  PHONE_RECENTLY_USED: 'PHONE_RECENTLY_USED',
};

export const ERROR_MESSAGES = {
  [ERROR_CODES.INVALID_PIN]: l10n('auth.byPhone.errors.invalidPinCode'),
  [ERROR_CODES.INVALID_PIN_PARAM]: l10n('auth.byPhone.errors.invalidPinCode'),
  [ERROR_CODES.PIN_EXPIRED]: l10n('auth.byPhone.errors.pinExpired'),
  [ERROR_CODES.SERVER_ERROR]: l10n('errors.SYSTEM_ERROR.text'),
  // TODO Необходимо добавить перевевод
  [ERROR_CODES.NETWORK_CONNECTION_ERROR]: 'Отсутствует подключение к интернету',
  [ERROR_CODES.PHONE_NOT_REGED]: 'Неверный номер телефона',
};
